import { trpc } from "@blis/trpc/react";

import { Section } from "../components/Section";
import { WorkflowsTable } from "../components/workflows/WorkflowsTable";

export function WorkflowsPage() {
  const { data } = trpc.admin.workflow.list.useQuery();
  return (
    <>
      <Section.Title>Rules</Section.Title>
      <WorkflowsTable workflows={data} />
    </>
  );
}
